import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";

const basePath = `${API_URLS.VEHICLE_V3}/vehicle-groups`;
const reportsConfigurationBasePathNew = `${API_URLS.GROUPS}/reports/configuration`;
const basePathGroups = API_URLS.GROUPS;

async function create(payload) {
	try {
		let response = await api.post(`${basePath}`, JSON.stringify(payload));
		let treated = errorHandling.handleResponse(response, "vehicleGroupService.create");
		if (treated) return treated;
		return null;
	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.create");
		return null;
	}
}

async function update(payload) {
	try {
		let response = await api.put(`${basePath}/${payload.id ?? payload.vehicleGroupId}`, JSON.stringify(payload));
		let treated = errorHandling.handleResponse(response, "vehicleGroupService.update");
		if (treated) return treated;
		return null;
	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.update");
		return null;
	}
}

async function defineDefault(id) {
	try {
		let response = await api.patch(`${basePath}/${id}/default`);
		let treated = errorHandling.handleResponse(response, "vehicleGroupService.defineDefault");
		if (treated) return treated;
		return null;
	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.defineDefault");
		return null;
	}
}

async function remove(id) {
	try {
		let response = await api.delete(`${basePath}/${id}`);
		let treated = errorHandling.handleResponse(response, "vehicleGroupService.remove");
		if (treated) return treated;
		return treated;
	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.remove");
		return error.response.data.details ?? null;
	}
}

async function fetchGroups() {
	try {
		let response = await api.get(`${API_URLS.VEHICLE_V3}/vehicle-groups`);
		let treated = errorHandling.handleResponse(response, "vehicleGroupService.fetchGroups");
		if (treated) return treated;
		return null;
	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.fetchGroups");
		return null;
	}
}

async function getGroupById(id) {
	try {
		let response = await api.get(`${API_URLS.VEHICLE_V3}/vehicle-groups/${id}`);
		let treated = errorHandling.handleResponse(response, "vehicleGroupService.getGroupById");
		if (treated) return treated;
		return null;
	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.getGroupById");
		return null;
	}
}

const toTimeString = (time) => {
	if (!time) return "00:00:00";
	return time.length === 5 ? `${time}:00` : time;
};

async function sendMovement(vehicleGroupId, payload) {
	try {
		const body = {
			vehicleGroupId: Number(vehicleGroupId),
			weekdayMovementCheck: payload.checkMovWeekdaysFlag,
			weekdayMovementStartTime: toTimeString(payload.checkMovWeekdaysStart),
			weekdayMovementEndTime: toTimeString(payload.checkMovWeekdaysEnd),
			saturdayMovementCheck: payload.checkMovSaturdayFlag,
			saturdayMovementStartTime: toTimeString(payload.checkMovSaturdayStart),
			saturdayMovementEndTime: toTimeString(payload.checkMovSaturdayEnd),
			sundayMovementCheck: payload.checkMovSundayFlag,
			sundayMovementStartTime: toTimeString(payload.checkMovSundayStart),
			sundayMovementEndTime: toTimeString(payload.checkMovSundayEnd),
		};
		let response = await api.put(`${basePathGroups}/configuration/movement`, JSON.stringify(body));
		let treated = errorHandling.handleResponse(response, "vehicleGroupService.sendMovement");
		if (treated) return treated;
		return null;
	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.sendMovement");
		return null;
	}
}

async function sendSpeed(vehicleGroupId, payload) {
	try {
		const body = {
			vehicleGroupId: Number(vehicleGroupId),
			urbanSpeedCheck: payload.urbanSpeedCheck,
			urbanSpeed: Number(payload.urbanSpeedValue),
			highwaySpeedCheck: payload.highwaySpeedCheck,
			highwaySpeed: Number(payload.highwaySpeedValue),
		};
		let response = await api.put(`${basePathGroups}/configuration/velocity`, JSON.stringify(body));
		let treated = errorHandling.handleResponse(response, "vehicleGroupService.sendSpeed");
		if (treated) return treated;
		return null;
	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.sendSpeed");
		return null;
	}
}

async function insertEmail(id, payload) {
	try {
		let response = await api.post(`${API_URLS.VEHICLE_V3}/groups/${id}/config/emails`, JSON.stringify(payload));
		let treated = errorHandling.handleResponse(response, "vehicleGroupService.insertEmail");
		if (treated) return treated;
		return null;
	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.insertEmail");
		return null;
	}
}

async function listEmail(groupId, vehicleGroupTypeEmailId) {
	try {
		let response = await api.get(`${API_URLS.VEHICLE_V3}/groups/${groupId}/config/emails?vehicleGroupTypeEmailId=${vehicleGroupTypeEmailId}`);
		let treated = errorHandling.handleResponse(response, "vehicleGroupService.listEmail");
		if (treated) return treated;
		return null;
	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.listEmail");
		return null;
	}
}

async function deleteEmail(groupId, vehicleGroupEmailId) {
	try {
		let response = await api.delete(`${API_URLS.VEHICLE_V3}/groups/${groupId}/config/emails?emailId=${vehicleGroupEmailId}`);
		let treated = errorHandling.handleResponse(response, "vehicleGroupService.deleteEmail");
		if (treated) return treated;
		return null;
	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.deleteEmail");
		return null;
	}
}

async function sendGroups(payload) {
	try {
		let response = await api.patch(`${basePath}/vehicles/group`, JSON.stringify(payload));
		let treated = errorHandling.handleResponse(response, "vehicleGroupService.sendGroups");
		if (treated) return treated;
		return null;
	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.sendGroups");
		return null;
	}
}

async function bindUsersGroups(payload) {
	try {
		let response = await api.patch(`${basePath}/user-vehicle-groups`, JSON.stringify(payload));
		let treated = errorHandling.handleResponse(response, "controlService.bindUsersGroups");
		if (treated) return treated;
		return null;
	} catch (error) {
		errorHandling.cathError(error, "controlService.bindUsersGroups");
		return null;
	}
}

async function unbindUsersGroups(payload) {
	try {
		const response = await api.delete(`${basePath}/user-vehicle-groups`, { data: payload });
		if (response.status >= 200 && response.status < 300) return true;
		const treated = errorHandling.handleResponse(response, "controlService.unbindUsersGroups");
		return treated ?? false;
	} catch (error) {
		errorHandling.cathError(error, "controlService.unbindUsersGroups");
		return false;
	}
}

async function sendReportsConfigurationPdf(payload) {
	try {
		let response = await api.put(`${reportsConfigurationBasePathNew}/pdf`, JSON.stringify(payload));
		let treated = errorHandling.handleResponse(response, "vehicleGroupService.sendReportsConfigurationPdf");
		if (treated) return treated;
		return null;
	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.sendReportsConfigurationPdf");
		return null;
	}
}

async function sendReportsConfigurationXls(payload) {
	try {
		let response = await api.put(`${reportsConfigurationBasePathNew}/xls`, JSON.stringify(payload));
		let treated = errorHandling.handleResponse(response, "vehicleGroupService.sendReportsConfigurationXls");
		if (treated) return treated;
		return null;
	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.sendReportsConfigurationXls");
		return null;
	}
}

async function sendReportsConfigurationKmz(payload) {
	try {
		let response = await api.put(`${reportsConfigurationBasePathNew}/kmz`, JSON.stringify(payload));
		let treated = errorHandling.handleResponse(response, "vehicleGroupService.sendReportsConfigurationKmz");
		if (treated) return treated;
		return null;
	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.sendReportsConfigurationKmz");
		return null;
	}
}

async function sendHighSpeedConfiguration(payload) {
	try {
		let response = await api.put(`${reportsConfigurationBasePathNew}/high-speed`, JSON.stringify(payload));
		let treated = errorHandling.handleResponse(response, "vehicleGroupService.sendHighSpeedConfiguration");
		if (treated) return treated;
		return null;
	} catch (error) {
		errorHandling.cathError(error, "vehicleGroupService.sendHighSpeedConfiguration");
		return null;
	}
}

export const vehicleGroupService = {
	create,
	update,
	remove,
	fetchGroups,
	getGroupById,
	defineDefault,
	sendMovement,
	sendSpeed,
	insertEmail,
	listEmail,
	deleteEmail,
	sendGroups,
	bindUsersGroups,
	unbindUsersGroups,
	sendReportsConfigurationPdf,
	sendReportsConfigurationXls,
	sendReportsConfigurationKmz,
	sendHighSpeedConfiguration
};
